import { CardMedia } from '@mui/material';
import { isEmpty, isEqual } from 'lodash';
import { memo, useMemo } from 'react';
import placeholderImageUrl from 'src/assets/images/placeholder.png';
import { GcfComponentScreen } from 'src/components/gcfComponentScreen';
import { getGCFComponentScale, getGCFSections } from 'src/utils/gcf-helper';

import { GCFComponentLayoutProps } from './GcfComponentLayout.interface';
import { GCFComponentLayoutWrapper } from './GcfComponentLayoutWrapper';

export const GCFComponentLayout = memo(
  (props: GCFComponentLayoutProps) => {
    const componentSize = useMemo(() => {
      return (
        props.layout?.screens.reduce(
          (acc, screen) => {
            acc.width += screen.width;
            acc.height = Math.max(acc.height, screen.height);

            return acc;
          },
          { width: 0, height: 0 },
        ) ?? { width: 0, height: 0 }
      );
    }, [props.layout?.screens]);

    const scale = useMemo(() => {
      return props.fullSize
        ? 1
        : getGCFComponentScale(
            componentSize.width,
            componentSize.height,
            !!props.fullWidth,
            props.containerSize?.size?.width,
            props.containerSize?.size?.height,
          );
    }, [
      componentSize.height,
      componentSize.width,
      props.containerSize?.size?.width,
      props.containerSize?.size?.height,
      props.fullWidth,
      props.fullSize,
    ]);

    return isEmpty(props.assemblyComponents) ? (
      <CardMedia
        component="img"
        height="100%"
        width="100%"
        image={placeholderImageUrl}
      />
    ) : (
      <GCFComponentLayoutWrapper>
        {props.layout?.screens.map((screen, index) => {
          return (
            <GcfComponentScreen
              key={screen.layoutScreenId}
              width={screen.width}
              height={screen.height}
              name={screen.name}
              sequence={screen.channel_screen_sequence}
              sections={getGCFSections(props.assemblyComponents, screen)}
              scale={scale}
              testid={`screen-${index}`}
              productFilters={props.productFilters}
              productVariationFilters={props.productVariationFilters}
              skipProductsApiOnEmptyFilters={
                props.skipProductsApiOnEmptyFilters
              }
            />
          );
        })}
      </GCFComponentLayoutWrapper>
    );
  },
  (prevProps, nextProps) => {
    return isEqual(prevProps, nextProps);
  },
);
